export default __webpack_public_path__ + "static/media/q.4e34105a.svg";